export enum SignalUserPlanStatusEnum {
    ACTIVE = 1,
    PAUSED = 2,
    FAILED = 3, // failed to renew as example
}
